import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler } from '@angular/common/http';
import { Observable } from 'rxjs';
import { share } from 'rxjs/operators';
import { UITKPageLoadingIndicatorService } from '@uhg-harmony/uitk-angular';
import { LoaderService } from './loader-service';
@Injectable({
  providedIn: 'root',
})
export class HttpService extends HttpClient {
    currentRequests: number = 0;

    constructor(handler: HttpHandler, private plis: LoaderService) {
        super(handler);
    }

    public override get(url: string, options?: any): Observable<any> {
        // Add a request to the queue count
        this.incrementRequestCount();
        // Make the request and get a reference
        const response = super.get(url, options).pipe(share());
        // Subscribe to the request to taake action when it completes
        response.subscribe(null, error => {
            this.decrementRequestCount();
        }, () => {                  // On completion of the request decrease the request queue counter
            this.decrementRequestCount();
        });
        return response;
    }

    public override post(url: string, data: any, options?: any): Observable<any> {
        // Add a request to the queue count
        this.incrementRequestCount();
        // Make the request and get a reference
        const response = super.post(url, data, options).pipe(share());
        // Subscribe to the request to taake action when it completes
        response.subscribe(null, error => {
            this.decrementRequestCount();
        }, () => {                  // On completion of the request decrease the request queue counter
            this.decrementRequestCount();
        });
        return response;
    }

    public override delete(url, options?: any): Observable<any> {
        // Add a request to the queue count
        this.incrementRequestCount();
        // Make the request and get a reference
        const response = super.delete(url, options).pipe(share());
        // Subscribe to the request to taake action when it completes
        response.subscribe(null, error => {
            this.decrementRequestCount();
        }, () => {                  // On completion of the request decrease the request queue counter
            this.decrementRequestCount();
        });
        return response;
    }


    // Decrement the queue counter and if it reaches 0 hide the page loader
    public decrementRequestCount() {
        if (--this.currentRequests == 0) {
            this.plis.hide();

        }
    }

    // Increment the queue counter and if it is greater than 0 show the page loader
    public incrementRequestCount() {
        if (this.currentRequests++ == 0) {
            this.plis.show();
        }
    }


}
